import axios from "axios";
import OperationTypes from "../../../types";
import { ServerSideTypes } from "../../common/OperationCommonTypes";

export enum EnumTransactionType {
  RENT = "RENT",
  TRANSPORT = "TRANSPORT",
}

export enum EnumLocationType {
  PARKING_GO = "PARKING_GO",
  LMS = "DMS",
  COMPOUND = "COMPOUND",
  SHOP_REPAIR = "SHOP_REPAIR",
}

export enum EnumRentState {
  ONGOING_RENT = "ONGOING_RENT",
  CLOSED_RENT = "CLOSED_RENT",
  VOID_RENT = "VOID_RENT",
  FAILED_RENT = "FAILED_RENT",
}

export interface ITransactionHistoryRequest {
  tenant?: string;
  vin?: string;
  plate?: string;
  brandName?: string;
  modelName?: string;
  statusReasonCode?: string;
  statusReasonDescr?: string;
  transactionType?: string;
  expectedStartDatetimeFrom?: string | null;
  expectedStartDatetimeTo?: string | null;
  expectedStartLocationId?: string;
  expectedStartLocationType?: string;
  actualStartDatetimeFrom?: string | null;
  actualStartDatetimeTo?: string | null;
  actualStartLocationId?: string;
  actualStartLocationType?: string;
  expectedEndDatetimeFrom?: string | null;
  expectedEndDatetimeTo?: string | null;
  expectedEndLocationId?: string;
  expectedEndLocationType?: string;
  actualEndDatetimeFrom?: string | null;
  actualEndDatetimeTo?: string | null;
  actualEndLocationId?: string;
  actualEndLocationType?: string;
  transferRequestNumber?: string;
  internalDeliverynoteNumber?: string;
  externalDeliverynoteNumber?: string;
  ra?: string;
  rentState?: string;
}

const TransactionHistoryService = {
  get: {
    filterTransactionHistory: (
      data: ITransactionHistoryRequest,
      serverParams: ServerSideTypes.IParams
    ) => {
      if (!!data.vin || !!data.plate)
        return axios
          .get<ServerSideTypes.IResult<OperationTypes.TransactionHistory>>(
            "masterdatavehicle/transactionhistory/pagination",
            { params: { ...data, ...serverParams } }
          )
          .then((response) => response.data);

      return Promise.resolve<
        ServerSideTypes.IResult<OperationTypes.TransactionHistory>
      >({
        content: [],
        pageNumber: 0,
        pageSize: 10,
        totalElements: 0,
        totalPages: 0,
      });
    },
    allLocation: (tenant: string) => {
      const fixedParams = { pageNumber: 0, pageSize: 1000000 };
      return axios
        .get<ServerSideTypes.IResult<OperationTypes.Domain>>(
          "masterdatasupplier/location/locationsByFilters",
          {
            params: {
              tenant: tenant,
              pageNumber: fixedParams.pageNumber,
              pageSize: fixedParams.pageSize,
            },
          }
        )
        .then((response) => response.data.content);
    },
    statusReasonsCode: (tenant: string) => {
      const fixedParams = {
        valid: true,
        status: "NOT_AVAILABLE",
        pageNumber: 0,
        pageSize: 100000,
      };
      return axios
        .get<ServerSideTypes.IResult<OperationTypes.Domain>>(
          "masterdatavehicle/statusreason",
          {
            params: {
              tenant: tenant,
              valid: fixedParams.valid,
              status: fixedParams.status,
              pageNumber: fixedParams.pageNumber,
              pageSize: fixedParams.pageSize,
            },
          }
        )
        .then((response) => {
          return response.data.content;
        });
    },
    download: (data: ITransactionHistoryRequest) => {
      return axios.get<OperationTypes.TransactionHistory>(
        "masterdatavehicle/transactionhistory/excel",
        {
          params: data,
          responseType: "arraybuffer",
          headers: { "Access-Control-Allow-Origin": true },
        }
      );
    },
  },
};

export default TransactionHistoryService;
